import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Capnhatttdangkiem from "components/Dangkiem/Capnhatttdangkiem.js";
import Thongtindangkiemtable from "components/Dangkiem/Thongtindangkiemtable.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);

export default function TTdangkiem() {
  const classes = useStyles();
  const [ttdangkiem, setTtdangkiem] = React.useState([]);
  const [ttdangkiemvalue, setTtdangkiemvalue] = React.useState(0);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const handleClose = () => {
    setOpencapnhat(false);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getttdangkiem = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/gettrungtamdangkiemtheouser?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTtdangkiem(data);
        setTtdangkiemvalue(data[0].id);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getttdangkiem();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={() => setOpencapnhat(true)}
          >
            Cập nhật
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 6 }}>
        <Thongtindangkiemtable doanhnghiep={ttdangkiem} />
      </GridItem>
      <Modal
        open={opencapnhat}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={10}>
                      <FormControl style={{ width: "100%", marginTop: "10px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Cập nhật trung tâm đăng kiểm
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <Capnhatttdangkiem ttdangkiemvalue={ttdangkiemvalue} />
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </GridContainer>
  );
}
